// this is temporary on core swag, going to be moved to swag-space-x shortly
import { ResellerAdminMode } from 'swag-common/constants/reseller.constants';
import React from 'react';
import { SwagButton } from '@ezetech/swag-space-x';
import { ConfirmExitResellerModePopup } from '../confirm-exit-reseller-mode-popup';
import { StoreLinkAndMakeItLivePopup } from '../store-link-and-make-it-live-popup';
import { BottomInfoBar } from '../bottom-info-bar';
import classes from './reseller-colored-frame.scss';
export const ResellerColoredFrameComponent = ({
  labelText,
  infoBarText,
  resellerAdminMode = ResellerAdminMode.Browse,
  shouldShowCreateCBSButton,
  onButtonClick,
  onCreateCBSClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.top
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.right
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.bottom
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.left
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.labelContainer
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.labelText
  }, labelText), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonBlock
  }, infoBarText && /*#__PURE__*/React.createElement(BottomInfoBar, {
    text: infoBarText
  }), /*#__PURE__*/React.createElement(SwagButton, {
    size: "small",
    className: classes.exitButton,
    type: "dark",
    onClick: onButtonClick(resellerAdminMode)
  }, resellerAdminMode === ResellerAdminMode.EditingCBS ? 'Save and exit' : 'Exit'), shouldShowCreateCBSButton && /*#__PURE__*/React.createElement(SwagButton, {
    className: classes.cbsButton,
    size: "small",
    type: "dark",
    onClick: onCreateCBSClick
  }, "Create Curated Brand Site"))), /*#__PURE__*/React.createElement(ConfirmExitResellerModePopup, {
    resellerAdminMode: resellerAdminMode
  }), /*#__PURE__*/React.createElement(StoreLinkAndMakeItLivePopup, null));
};